<template>
  <HomePage v-if="isGeneralUser" />
  <InternalHomePage v-else />
</template>

<script>
import HomePage from "@/views/HomePage";
import InternalHomePage from "@/views/InternalHomePage";

export default {
  name: "HomeEntryPage",
  components: {
    HomePage,
    InternalHomePage,
  },
  computed: {
    isGeneralUser() {
      return this.$enum.roleType.isGeneralUser();
    },
  },
};
</script>
